
import { defineComponent, computed, onMounted, watch, nextTick, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import KTToolbar from "@/layout/toolbar/Toolbar.vue";
import KTAside from "@/layout/aside/Aside.vue";
import KTHeader from "@/layout/header/Header.vue";
import KTFooter from "@/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/LayoutService";
import KTScrollTop from "@/layout/extras/ScrollTop.vue";
import KTLoader from "@/components/Loader.vue";
import { Actions } from "@/store/enums/StoreEnums";
import { MenuComponent } from "@/assets/ts/components";
import { reinitializeComponents } from "@/core/plugins/keenthemes";
import { removeModalBackdrop } from "@/core/helpers/dom";
import {
  toolbarDisplay,
  loaderEnabled,
  contentWidthFluid,
  loaderLogo,
  asideEnabled,
  subheaderDisplay,
  themeLightLogo,
  themeDarkLogo,
} from "@/core/helpers/config";
import ApiService from "@/core/services/ApiService";
import { IBreadcrumbs } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "Layout",
  components: {
    KTAside,
    KTHeader,
    KTFooter,
    KTScrollTop,
    KTLoader,
    KTToolbar
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    ApiService.setHeader();
    onBeforeMount(async () => {
      await store.dispatch(Actions.LOAD_PERMISSIONS);
    })
    // show page loading
    store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

    // initialize html element classes
    HtmlClass.init();

    const pageTitle = computed(() => {
      return store.state.BreadcrumbsModule.title;
    });

    const breadcrumbs = computed<IBreadcrumbs[]>(() => {
      return store.state.BreadcrumbsModule.objectBreadcrumbs;
    });

    onMounted(() => {

      if (!store.getters.isUserAuthenticated) {
        router.push({name: "sign-in"});
      }

      nextTick(() => {
        reinitializeComponents();
      });

      // Simulate the delay page loading
      setTimeout(() => {
        // Remove page loader after some time
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      }, 500);
    });

    watch(
      () => route.path,
      () => {
        MenuComponent.hideDropdowns(undefined);
        // check if current user is authenticated
        if (!store.getters.isUserAuthenticated) {
          router.push({name: "sign-in"});
        }

        nextTick(() => {
          reinitializeComponents();
        });
        removeModalBackdrop();
      }
    );

    return {
      toolbarDisplay,
      loaderEnabled,
      contentWidthFluid,
      loaderLogo,
      asideEnabled,
      subheaderDisplay,
      pageTitle,
      breadcrumbs,
      themeLightLogo,
      themeDarkLogo,
    };
  },
});
